module.exports = __webpack_public_path__ + "img/partners13.0e5774cf.png";